module.exports = __webpack_public_path__ + "static/media/RULEBOOK_JAPANESE.80fb58cf.pdf";